import api from './axios';

export interface BlogPost {
  id: number;
  title: string;
  titleZh: string | null;
  titleCn: string | null;
  slug: string;
  content: string;
  contentZh: string | null;
  contentCn: string | null;
  featuredImageUrl: string | null;
  authorId: string;
  categoryId: number;
  tags: string[];
  status: string;
  seoTitle: string | null;
  seoTitleZh: string | null;
  seoTitleCn: string | null;
  seoDescription: string | null;
  seoDescriptionZh: string | null;
  seoDescriptionCn: string | null;
  publishedAt: string;
  viewCount: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const getBlogPostBySlug = async (slug: string): Promise<BlogPost> => {
  const response = await api.get(`/api/page/posts/slug/${slug}`);
  return response.data;
};

export const getBlogPosts = async (): Promise<BlogPost[]> => {
  const response = await api.get('/api/page/posts');
  return response.data;
};
